import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

function NavBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const username = localStorage.getItem("username");
  const token = localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    localStorage.removeItem("username");
    navigate("/login");
  };

  // check if user is in dashboard (only then show cart)
  const isUserDashboard = location.pathname.startsWith("/userdashboard");

  return (
    <nav
      style={{
        backgroundColor: "#17a965ff",
        color: "#fff",
        padding: "15px 25px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{ fontSize: "20px", fontWeight: "bold" }}>🛍️ KingShop</div>

      <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
        <Link to="/home" style={linkStyle}>Home</Link>

        {/* Cart only visible on user dashboard */}
        {isUserDashboard && <Link to="/cart" style={linkStyle}>Cart</Link>}

        {token ? (
          <>
            <span style={{ fontWeight: "500" }}>
              Welcome, {username || "User"}
            </span>
            <button onClick={handleLogout} style={buttonStyle}>
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login" style={linkStyle}>Login</Link>
            <Link to="/register" style={linkStyle}>Register</Link>
          </>
        )}
      </div>
    </nav>
  );
}

const linkStyle = {
  color: "white",
  textDecoration: "none",
  fontWeight: "500",
};

const buttonStyle = {
  backgroundColor: "white",
  color: "#007bff",
  border: "none",
  borderRadius: "5px",
  padding: "5px 10px",
  cursor: "pointer",
  fontWeight: "500",
};

export default NavBar;
